import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Card } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getProduct } from 'Services/Features/Product/Utils/productUtils';
import CustomLoader from 'Component/Common/CustomLoader';
import FindProduct from './Filter/FindProduct';
import ProductTable from './ProductTable';

const ProductContain = () => {
    const dispatch = useDispatch();
    const products = useSelector((state) => state.product.products);
    const loading = useSelector((state) => state.product.loading);
    const error = useSelector((state) => state.product.error);
    const [refetch, setRefetch] = useState(false);
    const filters = useSelector(state => state.product.filters);

    useEffect(() => {
        dispatch(getProduct(filters));
        window.scrollTo(0, 0);
    }, [dispatch, refetch]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <Fragment>
            <Col md="12" className="project-list">
                <Card className="px-3">
                    <FindProduct />
                </Card>
            </Col>
            <Col xl="12" className="xl-80">
                <Row>
                    {loading ? (
                        <CustomLoader />
                    ) : loading === false && products.length === 0 ? (
                        <Col md="12">
                            <div className="no-data-found d-flex flex-column align-items-center justify-content-center" style={{ height: '300px' }}>
                                <i className="fa fa-search" style={{ fontSize: '100px', color: '#ccc', marginBottom: '20px' }}></i>
                                <h5 style={{ fontSize: '24px' }}>Produk Tidak Ditemukan</h5>
                            </div>
                        </Col>
                    ) : (
                        <ProductTable setRefetch={setRefetch} />
                    )}
                </Row>
                </Col>
        </Fragment>
    );
};

export default ProductContain;